<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <SmallSquare class="m-b-20" content='1、请录入准确的门店类型，便于总部对门店的管理以及门店自身财务运营等管理
2、请录入准确的门店地理位置定位，便于用户通过定位导航搜索到门店进行自提等到店服务' :padding='false'></SmallSquare>
      <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <!-- 基本信息 -->
        <div class=" s_over_h mb25">
          <div class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333 mb25">
            <p>基本信息</p>
            <p class='m-l-10 s_shou fz-14 m-t-5' v-if="open[0]==true" @click="open[0]=!open[0]">收起
              <UpOutlined />
            </p>
            <p class='m-l-10 s_shou fz-14 m-t-5' v-if="!open[0]" @click="open[0]=!open[0]">展开
              <DownOutlined />
            </p>
          </div>
          <div class="s_ptb0lr24" v-show="open[0]">
            <a-form-item ref="store_logo" label="门店LOGO" name="store_logo" help='LOGO将展示在微信端的门店页，最多可上传1张图片，推荐正方形比例图片，例如：120*120px' 
            v-if='($route.query.type =="look"&&form.store_logo) ||$route.query.type !="look"  '>
              <div class="s_po_re" v-if='$route.query.type !="look"'>
           
                <material :groupType='1'   :image="form.store_logo" :max="1" v-on:handlechoose="(data)=>{form.store_logo=data}" v-on:handledel="(data)=>{form.store_logo=''}" />
                <div class="s_po_ab_bl" style="width: 100%;height: 100%;" v-if='$route.query.type =="look" || $route.query.type == "review"'></div>
              </div>
              <div class='ant-upload-list ant-upload-list-picture-card' v-else>
                <div class='ant-upload-list-picture-card-container'>
                  <span>
                    <div class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture-card">
                      <div class="ant-upload-list-item-info">
                        <img :src="info.picdomain+'/'+form.store_logo" class='ant-upload-list-item-image' />
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </a-form-item>
            <a-form-item ref="store_name" label="门店名称" name="store_name" help='不应含有地区、地址、分店名、括号、特殊字符等信息，错误示例：北京XXX公司（XX）'>
              <a-row :gutter="16">
                <a-col :span="12">
                  <a-input v-model:value="form.store_name" placeholder='请输入门店名称' :maxlength="30" :readonly='$route.query.type =="look" || $route.query.type == "review"' />
                </a-col>
                <a-col :span="12">
                  <p>最多30个字</p>
                </a-col>
              </a-row>
            </a-form-item>
         
            <a-form-item ref="type_id" label="门店类型" name="type_id">
              <a-row :gutter="16">
                <a-col :span="12">
                  <a-select v-model:value="form.type_id" placeholder="请选择经门店类型" @change="changeStoreType" :disabled='$route.query.type == "look" || $route.query.type == "review"|| (form.type_store_type==4&&$route.query.type == "edit")'>
                    <a-select-option v-for='item in typeList' :key='item.type_id' :value="item.type_id">
                      {{item.type_name}}</a-select-option>
                  </a-select>
                </a-col>
                <!-- <a-col :span="12">
                  <a href="javascript:;" @click="showDealerType = true">添加门店类型</a>
                </a-col> -->
              </a-row>
            </a-form-item>
               <a-form-item label="所属品牌">
                <selectBrand  v-model:value="form.sub_brand_id" :sub_brand_id="Number(form.sub_brand_id)" :disabled='$route.query.type == "look"' />
                  <a-button class="m-l-10" @click="form.sub_brand_id=''" :disabled='$route.query.type == "look"'>清空</a-button>
              </a-form-item>
             <a-form-item ref="up_name" label="所属上级" name="up_name" v-if="form.type_store_type!='4'&&form.type_store_type">
              <a-row :gutter="16">
                <a-col :span="12">
                  <a-input v-model:value="form.up_name" placeholder='请选择所属上级' readonly />
                </a-col>
                <a-col :span="12">
                  <a-button type="primary" @click='showDealer = true' :disabled='$route.query.type == "look" || $route.query.type == "review"'>
                    选择
                  </a-button>
                </a-col>
              </a-row>
            </a-form-item>
            <!-- <a-form-item ref="level_id" label="门店级别" name="level_id">
              <a-row :gutter="16">
                <a-col :span="12">
                  <a-select v-model:value="form.level_id" placeholder="请选择门店级别" :disabled='$route.query.type == "look" || $route.query.type == "review"'>
                    <a-select-option v-for='item in levelList' :key='item.id' :value="item.id">{{item.level_name}}
                    </a-select-option>
                  </a-select>
                </a-col>
                <a-col :span="12">
                  <a href="javascript:;" @click="showDealerLevel = true">添加门店级别</a>
                </a-col>
              </a-row>
            </a-form-item> -->
            <a-form-item ref="store_pid" label="上级门店" name="store_pid"  v-if="form.type_store_type=='4'" :rules="[{ required: true, message: '请选择上级门店' }]">
              <a-row :gutter="16">
                <a-col :span="12">
                  <a-input v-model:value="form.store_pid_name" placeholder='请选择所属上级' readonly />
                </a-col>
                <a-col :span="12">
                  <a-button type="primary" @click='showStore = true' :disabled='$route.query.type == "look" || $route.query.type == "review"'>
                    选择
                  </a-button>
                </a-col>
              </a-row>
            </a-form-item>
            
            <!-- 性质 -->
             <a-form-item label="门店性质"  required>
                <a-radio-group  v-model:value="form.is_fictitious" :disabled='$route.query.type =="look" || $route.query.type == "review"'>
                  <a-radio :value="0">实体+虚拟店</a-radio>
                  <a-radio :value="1">虚拟店</a-radio>
                </a-radio-group>
             </a-form-item>

            <a-form-item required ref="store_address" label="门店地址" name="store_address">
              <a-row :gutter="16">
                <a-col :span="12">
                  <selectCity class="m-r-20" :addressData='address' placeholder="请选择门店地址" :disabled='$route.query.type == "look" || $route.query.type == "review"' v-on:citychange='citychange'></selectCity>
                </a-col>
              </a-row>
            </a-form-item>
            <a-form-item ref="street" label="详细地址" name="street">
              <a-row :gutter="16">
                <a-col :span="12">
                  <a-input v-model:value="form.street" placeholder='请输入详细地址' :readonly='$route.query.type =="look" || $route.query.type == "review"' @change="changeVal" />
                </a-col>
              </a-row>
            </a-form-item>
            <a-form-item ref="lat" label="经纬度" name="lat">
              <a-row :gutter="16">
                <a-col :span="6">
                  <a-input v-model:value="form.lat" placeholder='请输入经度' :readonly='$route.query.type =="look" || $route.query.type == "review"' />
                </a-col>
                <a-col :span="6">
                  <a-input v-model:value="form.lng" placeholder='请输入纬度' :readonly='$route.query.type =="look" || $route.query.type == "review"' />
                </a-col>
                <a-col :span="12">
                  <a-button type="primary" @click='showMap = true' :disabled='$route.query.type == "look" || $route.query.type == "review"'>
                    搜索
                  </a-button>
                </a-col>
              </a-row>
            </a-form-item>
            <a-form-item ref="" label="推荐门店" name="" v-if='$route.query.type !== "add"'>{{form.extension_store_name}}</a-form-item>
          </div>
        </div>
        <!-- 负责人信息 -->
        <div class=" s_over_h mb25" v-if="form.type_store_type!='4'||$route.query.type=='look'">
          <div class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333 mb25">负责人信息
            <p class='m-l-10 s_shou fz-14 m-t-5' v-if="open[1]==true" @click="open[1]=!open[1]">收起
              <UpOutlined />
            </p>
            <p class='m-l-10 s_shou fz-14 m-t-5' v-if="!open[1]" @click="open[1]=!open[1]">展开
              <DownOutlined />
            </p>
          </div>
          <div class="s_ptb0lr24" v-show="open[1]">
            <a-form-item ref="clerk_name" label="负责人" name="clerk_name" >
              <a-row :gutter="16">
                <a-col :span="12">
                  <a-input v-model:value="form.clerk_name" placeholder='请输入门店负责人姓名' :disabled="$route.query.type=='edit'" :readonly='$route.query.type =="look"|| $route.query.type == "review"' />
                </a-col>
                <a-col :span="12">
                  <p>最多10个字</p>
                </a-col>
              </a-row>
            </a-form-item>
            <a-form-item ref="clerk_phone" label="联系手机" name="clerk_phone" >
              <a-row :gutter="16">
                <a-col :span="12">
                  <a-input v-model:value="form.clerk_phone" placeholder='请输入门店负责人联系手机' :maxlength='11' :disabled="$route.query.type=='edit'" :readonly='$route.query.type =="look"|| $route.query.type == "review"' />
                </a-col>
                <a-col :span="12">
                  <p>11位手机号码（联系手机也是门店账号）</p>
                </a-col>
              </a-row>
            </a-form-item>
            <a-form-item ref="clerk_password" label="登录密码" name="clerk_password" v-if='$route.query.type =="add"'>
              <a-row :gutter="16">
                <a-col :span="12">
                  <a-input v-model:value="form.clerk_password" placeholder='请输入登录密码' />
                </a-col>
                <a-col :span="12">
                  <p>6-20个非中文字符（默认密码1-6）</p>
                </a-col>
              </a-row>
            </a-form-item>
          </div>
        </div>
        <!-- 服务信息 -->
        <div class=" s_over_h mb25">
          <div class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333 mb25">服务信息
            <p class='m-l-10 s_shou m-t-5 fz-14' v-if="open[2]==true" @click="open[2]=!open[2]">收起
              <UpOutlined />
            </p>
            <p class='m-l-10 s_shou m-t-5 fz-14' v-if="!open[2]" @click="open[2]=!open[2]">展开
              <DownOutlined />
            </p>
          </div>
          <div class="s_ptb0lr24" v-show="open[2]">
            <a-form-item ref="" label="门店图片" name="" help='图片将展示在微信端的门店页，最多可上传6张图片，尺寸为：640*340px' v-if='
           ( $route.query.type =="look"&&form.image.length)|| $route.query.type !="look"'>
              <div class="s_po_re" v-if='$route.query.type !="look"'>
                <material :groupType='1' :imageList="form.image" :max="6" v-on:handlechoose="(data)=>{form.image=data}" v-on:handledel="(data)=>{form.image=data}" />
                <div class="s_po_ab_bl" style="width: 100%;height: 100%;" v-if='$route.query.type =="look" || $route.query.type == "review"'></div>
              </div>
              <div class='ant-upload-list ant-upload-list-picture-card' v-if='$route.query.type =="look"'>
                <div class='ant-upload-list-picture-card-container' v-for="v in form.image" :key='v'>
                  <span>
                    <div class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture-card">
                      <div class="ant-upload-list-item-info">
                        <img :src="info.picdomain+'/'+v" class='ant-upload-list-item-image' />
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </a-form-item>
            <a-form-item ref="" label="简介" name="">
              <a-row :gutter="16">
                <a-col :span="12">
                  <a-textarea v-model:value="form.brief" showCount :maxlength="200" placeholder="对品牌或门店的简要介绍" :rows="4" :readonly='$route.query.type =="look" || $route.query.type == "review"' />
                </a-col>
              </a-row>
            </a-form-item>
          </div>
        </div>
        <a-form-item :wrapper-col="{ span: 8, offset: 3 }" v-if='$route.query.type == "add" || $route.query.type == "edit"'>
          <a-button style="width:100px" type="primary" @click="onSubmit">
            提交
          </a-button>
        </a-form-item>
      </a-form>
      <a-form ref="ruleForm1" :model="form1" :rules="rules1" :label-col="labelCol" :wrapper-col="wrapperCol" v-if='$route.query.type == "review"'>
        <!-- 门店审核 -->
        <div class=" s_over_h mb25">
          <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333 mb25">门店审核</p>
          <div class="s_ptb0lr24">
            <a-form-item ref="" label="添加人" name="">
              <p class="s_c333">{{form.distributor_name || '总部'}}</p>
            </a-form-item>
            <a-form-item ref="" label="审核结果" name="" v-if="form.status!=0">
              <p class="s_c333">{{form.status==1?'审核通过':'审核不通过'}}</p>
            </a-form-item>
            <a-form-item ref="" label="审核人" name="" v-if="form.status!=0">
              <p class="s_c333">{{form.reviewer || '-'}}</p>
            </a-form-item>
            <a-form-item ref="" label="备注" name="" v-if="form.status!=0">
              <p class="s_c333">{{form.remarks || '-'}}</p>
            </a-form-item>
            <a-form-item ref="status" label="审核" name="status" v-if="form.status==0">
              <a-radio-group class="mb10" v-model:value="form1.status" @change="onChange">
                <a-radio :value="1">
                  <span class="s_c333">通过</span>
                </a-radio>
                <a-radio :value="2">
                  <span class="s_c333">不通过</span>
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <a-form-item ref="reviewer" label="审核人" name="reviewer" v-if="form.status==0">
              <a-row :gutter="16">
                <a-col :span="12">
                  <a-input v-model:value="form1.reviewer" :maxlength="10" placeholder='请输入审核人姓名' />
                </a-col>
                <a-col :span="12">
                  <p>最多10个字</p>
                </a-col>
              </a-row>
            </a-form-item>
            <a-form-item :ref="form1.status == 2 ? 'remarks':''" label="备注" :name="form1.status == 2 ? 'remarks':''" v-if="form.status==0" :rules="[{ required: true, message: '请输入备注' }]">
              <a-row :gutter="16">
                <a-col :span="12">
                  <a-textarea v-model:value="form1.remarks" showCount :maxlength="200" :placeholder="form1.status == 2? '请输入审核不通过的原因':'请输入备注'" :rows="4" />
                </a-col>
              </a-row>
            </a-form-item>
          </div>
        </div>
        <a-form-item :wrapper-col="{ span: 8, offset: 3 }" v-if="form.status==0 || $route.query.type != 'review' ">
          <a-button style="width:100px" type="primary" v-has:storeReviewSubmit="onSubmit1">
            提交
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
  <a-modal  :keyboard="false" title="选择经纬度" centered v-model:visible="showMap" :width='1300' :footer="null" destroyOnClose>
    <gdmap v-on:confirm="confirm" :provinceData='mapProvince' :address='form.street' :lng='form.lng' :lat='form.lat'></gdmap>
  </a-modal>
  <a-modal  :keyboard="false" title="选择经销商" centered v-model:visible="showDealer" :width='1300' :footer="null" destroyOnClose>
    <selectDealer :is_sub_store="1" v-on:select="select" :mustShowHeadquarters='true'></selectDealer>
  </a-modal>
  <!-- <a-modal  :keyboard="false" title="添加门店类型" centered v-model:visible="showDealerType" :width='1300' :footer="null" destroyOnClose>
    <storeTypeAdd v-on:storetypesubmit="storetypesubmit"></storeTypeAdd>
  </a-modal> -->
  <a-modal  :keyboard="false" title="选择门店" v-model:visible="showStore" centered :width='1300' :footer="null" destroyOnClose>
    <selectChain v-on:select="storeSelect" :checkout='false'  :hiddenHead="true"  :dealer_id="form.pid" :type_id="form.type_id"></selectChain>
  </a-modal>
  <a-modal  :keyboard="false" title="添加门店级别" centered v-model:visible="showDealerLevel" :width='1300' :footer="null" destroyOnClose>
    <storeLevelAdd v-on:storelevelsubmit="storelevelsubmit"></storeLevelAdd>
  </a-modal>
</template>
<script>
import { ref, onMounted, reactive, toRefs, inject } from "vue";
import { message } from "ant-design-vue";
import { UpOutlined, DownOutlined } from "@ant-design/icons-vue";
import {
  storeAdd,
  getStoreMore,
  storeEdit,
  getPublicLevelList,
  getPublicTypeList,
  storeExamine,
  getStoreExamineMore,
} from "@/api/store";
import { iscode } from "@/utils/app";
import store from "@/store";
// 初始化默认筛选项数值
let defForm = {
  // store_code: '',
  store_name: "",
  up_name: "",
  pid: "",
  type_id: undefined,
  level_id: undefined,
  province_id: "",
  city_id: "",
  area_id: "",
  street: "",
  lng: "",
  lat: "",
  brief: "",
  image: [],
  clerk_name: "",
  phone: "",
  clerk_password: 123456,
  store_logo: "",
  is_sub_store: 1,
  is_fictitious:0
};
let defForm1 = {
  id: "",
  status: null,
  reviewer: "",
  remarks: "",
};
export default {
  components: {
    DownOutlined,
    UpOutlined,
  },
  setup() {
    let store_address = async () => {
      if (
        form.value.province_id == "" &&
        form.value.city_id == "" &&
        form.value.area_id == ""
      ) {
        return Promise.reject("请选择门店地址");
      } else {
        return Promise.resolve();
      }
    };
    const form = ref({ ...defForm });
    const form1 = ref({ ...defForm1 });
    let clerk_phone = async (rule, value) => {
      if (!value) {
        return Promise.reject("请输入手机号");
      }
      if (
        !/^(1)\d{10}$/.test(
          value
        )
      ) {
        return Promise.reject("手机号格式有误");
      } else {
        return Promise.resolve();
      }
    };
    const state = reactive({
      info: store.state.user.info,
      showStore: false,
      open: [true, true, true],
      levelList: [],
      typeList: [],
      address: [],
      mapProvince: {
        province_name: "",
        city_name: "",
        area_name: "",
      },
      showMap: false,
      showDealer: false,
      showDealerType: false,
      showDealerLevel: false,
      labelCol: { span: 3 },
      wrapperCol: { span: 10 },
      rules: {
        store_code: [
          { required: true, message: "请输入门店编号" },
          { max: 20, message: "最多20个字", trigger: "blur" },
        ],
        store_name: [
          { required: true, message: "请输入门店名称" },
          { max: 30, message: "最多30个字", trigger: "blur" },
        ],
        up_name: [{ required: true, message: "请选择所属上级" }],
        type_id: [{ required: true, message: "请选择门店类型" }],
        store_address: [{ required: true, validator: store_address }],
        street: [{ required: true, message: "请输入详细地址" }],
        lat: [{ required: true, message: "请选择经纬度" }],
      },
      clerk_password: [{ required: true, message: "请输入密码" }],

      rules1: {
        status: [{ required: true, message: "请选择是否通过审核" }],
        reviewer: [{ required: true, message: "请输入审核人" }],
        remarks: [{ required: true, message: "请输入审核不通过的原因" }],
      },
    });
    let store_type = async (rule, value) => {};
    const ruleForm = ref();
    const ruleForm1 = ref();
    const momentTime = inject("momentTime");
    const $route = inject("$route");
    const $Modal = inject("$Modal");
    const $router = inject("$router");
    const _lodash = inject("_lodash");
    // 经纬度选择完毕
    const confirm = (value) => {
      form.value.lat = value.lat;
      form.value.lng = value.lng;
      state.showMap = false;
    };
    //选择经销商
    const select = (e) => {
      if (e == 0) {
        form.value.pid = e;
        form.value.up_name = "总部";
      } else {
        form.value.pid = e.dealer_id;
        form.value.up_name = e.dealer_name;
      }
      state.showDealer = false;
    };
    //选择省市区
    const citychange = (e, s) => {
      if (
        state.mapProvince.province_name != s[0].name ||
        state.mapProvince.city_name != s[1].name ||
        state.mapProvince.area_name != s[2].name
      ) {
        //重置经纬度
        form.value.lat = "";
        form.value.lng = "";
      }

      form.value.province_id = e[0];
      form.value.city_id = e[1];
      form.value.area_id = e[2];
      state.mapProvince = {
        province_name: s[0].name,
        city_name: s[1].name,
        area_name: s[2].name,
      };
    };

    const changeVal = (e) => {
      //重置经纬度
      form.value.lat = "";
      form.value.lng = "";
    };

    // 获取类型列表
    const getType = async () => {
      let res = await getPublicTypeList().then((res) => res.data);
      if (iscode(res)) {
        state.typeList = res.data.data;
      } else {
        message.error(res.msg);
      }
    };
    //获取等级列表
    const getLevel = async () => {
      let res = await getPublicLevelList().then((res) => res.data);
      if (iscode(res)) {
        state.levelList = res.data.data;
      } else {
        message.error(res.msg);
      }
    };
    //获取详情
    const getMore = async (id) => {
      const hide = message.loading("正在加载中...", 0);
      let res;
      if ($route.query.type == "edit" || $route.query.type == "look") {
        res = await getStoreMore({ id: id }).then((res) => res.data);
      } else {
        res = await getStoreExamineMore({ id: id }).then((res) => res.data);
      }
      if (iscode(res)) {
        form.value = res.data;
        form.value.up_name = res.data.distributor_name
          ? res.data.distributor_name
          : "总部";
        form.value.image = res.data.imagelist;
        state.address = [
          res.data.province_id,
          res.data.city_id,
          res.data.area_id,
        ];
        state.mapProvince = {
          province_name: res.data.province || "",
          city_name: res.data.city || "",
          area_name: res.data.area || "",
        };
        setTimeout(hide);
      } else {
        setTimeout(hide);
        message.error(res.msg);
      }
    };
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(async () => {
          let res;
          const hide = message.loading("正在加载中...", 0);
          if ($route.query.type == "add") {
            res = await storeAdd({
              ...form.value,
              image: JSON.stringify(form.value.image),
            }).then((res) => res.data);
          } else {
            res = await storeEdit({
              ...form.value,
              image: JSON.stringify(form.value.image),
            }).then((res) => res.data);
          }
          if (iscode(res)) {
            setTimeout(hide);
            message.success(res.msg);
            setTimeout(() => {
              $router.go(-1);
            }, 1000);
          } else {
            setTimeout(hide);
            message.error(res.msg);
          }
        })
        .catch((error) => {
          message.error("请完善表单！");
        });
    };
    const onSubmit1 = () => {
      const hide = message.loading("正在加载中...", 0);
      ruleForm1.value
        .validate()
        .then(async () => {
          let res = await storeExamine({
            ...form1.value,
            id: $route.query.id,
          }).then((res) => res.data);
          if (iscode(res)) {
            setTimeout(hide);
            message.success(res.msg);
            setTimeout(() => {
              $router.go(-1);
            }, 1000);
          } else {
            setTimeout(hide);
            message.error(res.msg);
          }
        })
        .catch((error) => {
          message.error("请完善表单！");
        });
    };
    const storetypesubmit = () => {
      state.showDealerType = false;
      getType();
    };
    const storelevelsubmit = () => {
      state.showDealerLevel = false;
      getLevel();
    };
    onMounted(() => {
      getType();
      getLevel();
      if (
        $route.query.type == "edit" ||
        $route.query.type == "look" ||
        $route.query.type == "review"
      ) {
        getMore($route.query.id);
      } else {
        let rulesObj = {
          clerk_name: [
            { required: true, message: "请输入负责人姓名" },
            { max: 10, message: "最多10个字", trigger: "blur" },
          ],

          clerk_phone: [
            { required: true, message: "请输入负责人手机号" },
            {
              len: 11,
              message: "手机号长度有误，请输入11位手机号",
              trigger: "blur",
            },
            { validator: clerk_phone },
          ],
          clerk_password: [{ required: true, message: "请输入登录密码" }],
        };
        state.rules = _lodash.merge(state.rules, rulesObj);
      }
    });
    const changeStoreType=(e)=>{
      state.typeList.forEach(element => {
              if(element.type_id==e){
                form.value.type_store_type=element.store_type
              }
      });
    }
    const storeSelect = (data) => {
      form.value.store_pid_name=data.store_name
      form.value.store_pid=data.id
      state.showStore=false
    };
    return {
      form,
      form1,
      ...toRefs(state),
      ruleForm,
      ruleForm1,
      onSubmit,
      onSubmit1,
      confirm,
      citychange,
      select,
      storetypesubmit,
      storelevelsubmit,
      changeVal,
      storeSelect,
      changeStoreType
    };
  },
};
</script>
